<div class="px-4">
  <div class="flex w-full gap-3">
    <div class="w-full flex-1 overflow-x-auto overflow-y-hidden">
      <dojo-content-item-viewer
        [contentItemsFormArray]="formCtrl().controls.criterion"
        [isAllowedToEditImage]="isAllowedToEditImage()"
        [isAllowedToEditTable]="isAllowedToEditTable()"
        (editItem)="handleEditItem($event)"
      />
    </div>
    <div class="text-md text-primary font-medium italic">
      {{ state.formCtrlValue.mark_code.length ? state.formCtrlValue.mark_code : state.formCtrlValue.marks }}
    </div>
    @if (!editingOptions().hideBadges || editingOptions().allowMarkschemeEditing) {
      <dojo-selector-badge
        class="self-start"
        [disabled]="disabled()"
        (clicked)="setActive.emit()"
        [color]="MARKSCHEME_ITEM_TYPE_TO_COLOR[MarkschemeEditorItemEnum.MarkGroup]"
        [label]="MARKSCHEME_ITEM_TYPE_TO_SHORT_LABEL[MarkschemeEditorItemEnum.MarkGroup]"
        [longLabel]="MARKSCHEME_ITEM_TYPE_TO_LONG_LABEL[MarkschemeEditorItemEnum.MarkGroup]"
        [active]="isActive()"
        [matTooltip]="MARKSCHEME_ITEM_TYPE_TO_LONG_LABEL[MarkschemeEditorItemEnum.MarkGroup]"
      />
    }
  </div>

  @for (noteControl of formCtrl().controls.notes.controls; track $index) {
    <dojo-markscheme-note [note]="noteControl.value" class="my-3 mr-[80px] block" />
  }
</div>
